/*
 * Product Set Builder product routing — v2.04
 * Edit only the handles below when Shopify product URLs differ.
 */
(() => {
  const PRODUCTS = {
    1: '',
    2: 'wall-art-set-of-2-builder-mix-match-prints-frames-canvas',
    3: 'wall-art-set-of-3-builder-mix-match-prints-frames-canvas',
    4: 'wall-art-set-of-4-builder-mix-match-prints-frames-canvas',
    6: 'wall-art-set-of-6-builder-mix-match-prints-frames-canvas',
    8: 'wall-art-set-of-8-builder-mix-match-prints-frames-canvas',
    9: 'wall-art-set-of-9-builder-mix-match-prints-frames-canvas',
    12: 'wall-art-set-of-12-builder-mix-match-prints-frames-canvas'
  };

  const SUPPORTED_COUNTS = [1, 2, 3, 4, 6, 8, 9, 12];
  const AUTO_DERIVE_HANDLES = false;

  function normalizeHandle(value) {
    return String(value || '')
      .trim()
      .replace(/^https?:\/\/[^/]+/i, '')
      .replace(/^\/products\//, '')
      .replace(/[?#].*$/, '')
      .replace(/^\/+|\/+$/g, '');
  }

  function deriveHandle(count, currentHandle) {
    const current = normalizeHandle(currentHandle);
    if (!current) return '';

    if (/set-of-\d+/i.test(current)) {
      return current.replace(/set-of-\d+/i, `set-of-${count}`);
    }

    return '';
  }

  function resolveHandle(count, currentHandle) {
    const normalizedCount = Number(count);
    if (!SUPPORTED_COUNTS.includes(normalizedCount)) return '';
    const configured = normalizeHandle(PRODUCTS[normalizedCount]);
    if (configured) return configured;
    return AUTO_DERIVE_HANDLES ? deriveHandle(normalizedCount, currentHandle) : '';
  }

  function getCountForHandle(handle) {
    const normalized = normalizeHandle(handle);
    if (!normalized) return 0;

    const explicit = SUPPORTED_COUNTS.find(count => normalizeHandle(PRODUCTS[count]) === normalized);
    if (explicit) return explicit;

    const match = normalized.match(/set-of-(\d+)/i);
    const count = match ? Number(match[1]) : 0;
    return SUPPORTED_COUNTS.includes(count) ? count : 0;
  }

  window.PSBProductMapModule = {
    products: { ...PRODUCTS },
    supportedCounts: SUPPORTED_COUNTS.slice(),
    mainCount: 3,
    resolveHandle,
    getCountForHandle
  };

  window.dispatchEvent(new CustomEvent('psb:product-map-ready'));
})();
